import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import Layout from "./components/Layout";
import AgeVerification from "./components/AgeVerification";
import ScrollToTop from "./components/ScrollToTop";
import TagadaTrackerMount from "./components/TagadaTrackerMount";
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import DashboardPage from "./pages/DashboardPage";
import FAQPage from "./pages/FAQPage";
import AdminStockPage from "./pages/AdminStockPage";
import AdminInboxPage from "./pages/AdminInboxPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ShippingPolicyPage from "./pages/ShippingPolicyPage";
import RefundsPage from "./pages/RefundsPage";
import PreOrderPolicyPage from "./pages/PreOrderPolicyPage";
import ReferenceLibraryPage from "./pages/ReferenceLibraryPage";
import AdminPromoCodesPage from "./pages/AdminPromoCodesPage";
import AdminPromoReportPage from "./pages/AdminPromoReportPage";
import AdminReferencesPage from "./pages/AdminReferencesPage";
import AdminToolsPage from "./pages/AdminToolsPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import EmailVerifyPage from "./pages/EmailVerifyPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <ScrollToTop />
          <TagadaTrackerMount />
          <Toaster position="top-center" richColors style={{ top: '100px' }} />
          <AgeVerification />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/orders" element={<DashboardPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
              <Route path="/refunds" element={<RefundsPage />} />
              <Route path="/pre-orders" element={<PreOrderPolicyPage />} />
              <Route path="/references" element={<ReferenceLibraryPage />} />
              <Route path="/verify-email" element={<EmailVerifyPage />} />
              <Route path="/admin/stock" element={<AdminStockPage />} />
              <Route path="/admin/inbox" element={<AdminInboxPage />} />
              <Route path="/admin/orders" element={<AdminOrdersPage />} />
              <Route path="/admin/promo-codes" element={<AdminPromoCodesPage />} />
              <Route path="/admin/promo-codes/:code/report" element={<AdminPromoReportPage />} />
              <Route path="/admin/references" element={<AdminReferencesPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/admin/tools" element={<AdminToolsPage />} />
            </Routes>
          </Layout>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
